export function scrollToWithSpacing(element: Element, spacing: number = 20) {
  const { top } = element.getBoundingClientRect();
  const newScroll = window.scrollY + top - spacing;
  window.scrollTo(0, newScroll);
}
